import {api} from "./axiosConfig";
import Env from "../env";

interface AskResponse {
  response: string;
}

interface HistoryMessage {
  type: string;
  content: string;
  id?: string;
}

interface DeleteResponse {
  status: "success";
}

interface Message {
  id: number;
  texte: string;
  auteur: "user" | "bot" | "form";
}

interface BotApi {
  getMessage: (message: string, id: string) => Promise<AskResponse>;
  getHistory: (id: string) => Promise<HistoryMessage[]>;
  deleteConversation: (id: string) => Promise<DeleteResponse>;
  sendMail: (
    email: string,
    messages: Message[],
    consoleID?: string,
    phoneNumber?: string,
    orderId?: string
  ) => Promise<{status: string}>;
}

const URL_BOT = "/chatbot";

const BotApi: BotApi = {
  getMessage: async (message: string, id: string) => {
    const body = {
      message: message,
      conversationId: id,
    };

    const response = await api.request({
      baseURL: Env.CHATBOT_URL,
      url: `${URL_BOT}/ask`,
      method: "POST",
      data: body,
    });
    return response.data;
  },

  getHistory: async (id: string) => {
    const response = await api.request({
      baseURL: Env.CHATBOT_URL,
      url: `${URL_BOT}/history/${id}`,
      method: "GET",
    });
    return response.data;
  },

  deleteConversation: async (id: string) => {
    const response = await api.request({
      baseURL: Env.CHATBOT_URL,
      url: `${URL_BOT}/delete/${id}`,
      method: "POST",
    });
    return response.data;
  },

  sendMail: async (
    email: string,
    messages: Message[],
    consoleID?: string,
    phoneNumber?: string,
    orderId?: string
  ) => {
    const body = {
      email: email,
      messages: messages,
      consoleID: consoleID,
      phoneNumber: phoneNumber,
      orderId: orderId,
    };

    console.log("Sending mail with body:", body);

    const response = await api.request({
      baseURL: Env.CHATBOT_URL,
      url: `/ticket/send`,
      method: "POST",
      data: body,
    });
    return response.data;
  },
};

export default BotApi;
